import { Pipe, PipeTransform } from '@angular/core';
import { formatDateCell } from '../utility-functions/grid';
@Pipe({
  name: 'datetimeformat'
})
export class DateTimeFormatPipe implements PipeTransform {

  transform(value: any, args?: any): string {
    return formatDateCell(value)
  }

}
